export enum NamesFieldsFormProperties {
    properties = 'properties'
}
